import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayerPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 4v16l13 -8l-13 -8" })
});
export { SvgPlayerPlay as ReactComponent };
